import React, { useState } from 'react';
// Dialogs
import AccountFormDialog from 'dialogs/AccountForm.dialog';

type IProps = {}

const AccountsCreate:React.FC<IProps> = () => {
  const [show, setShow] = useState<boolean>(false);

  const handleShow = () => setShow(true);
  const handleHide = () => setShow(false);

  return (
    <>
      <div className="text-right mb-3">
        <button
          className="btn btn-primary btn-sm"
          type="button"
          onClick={handleShow}
        >Create account</button>
      </div>
      {show ? (
        <AccountFormDialog
          show={show}
          onHide={handleHide}
        />
      ) : null}
    </>
  )
}

export default AccountsCreate;
